import {MembersPageState} from '../types/state'

export const getMemberId = (state: MembersPageState) => state.user.viewedSiteMemberId

export const getUserId = (state: MembersPageState) => state.user.currentUserId

export const isOwnProfile = (state: MembersPageState) => getMemberId(state) === getUserId(state)
